export default {
  LOAD_USER_FORM_PAGE_START: 'LoadUserFormPageStart',
  LOAD_USER_FORM_PAGE_END: 'LoadUserFormPageEnd',
  CLEAR_USER_FORM_PAGE: 'ClearUserFormPage'
};